import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.75 4.08333H8.45833C10.3913 4.08333 11.9583 5.65034 11.9583 7.58333C11.9583 9.51633 10.3913 11.0833 8.45833 11.0833H4.66667",
		stroke: "currentColor",
		strokeWidth: 1.17,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.08333 1.75L1.75 4.08333L4.08333 6.41667",
		stroke: "currentColor",
		strokeWidth: 1.17,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUndo;
